import http, { httpV2 } from "../http.js";

const DashboardService = {
  dashboardCounts: () => httpV2.get(`dashboard/counts`),
  dashboardCountsGuestsArrivingToday: () =>
    httpV2.get(`dashboard/counts/guests-arriving-today`),
  dashboardCountsGuestsArrivingTomorrow: () =>
    httpV2.get(`dashboard/counts/guests-arriving-tomorrow`),
  dashboardCountsGuestsCurrentlyStaying: () =>
    httpV2.get(`dashboard/counts/guests-currently-staying`),
  dashboardCountsGuestsDepartingToday: () =>
    httpV2.get(`dashboard/counts/guests-departing-today`),
  dashboardCountsGuestsDepartingTomorrow: () =>
    httpV2.get(`dashboard/counts/guests-departing-tomorrow`),
  dashboardCountsGuestsLast30Days: () =>
    httpV2.get(`dashboard/counts/guests-last-30-days`),
  dashboardCountsHomeGuides: () => httpV2.get(`dashboard/counts/home-guides`),
  dashboardCountsAreaGuides: () => httpV2.get(`dashboard/counts/area-guides`),
  dashboardCountsScheduledMessages: () =>
    httpV2.get(`dashboard/counts/scheduled-messages`),
  dashboardCountsContacts: () => httpV2.get(`dashboard/counts/contacts`),
  dashboardCountsTextMessagesSent: (startDate, endDate) =>
    httpV2.get(
      `dashboard/counts/text-messages-sent?startDate=${startDate}&endDate=${endDate}`,
    ),
  dashboardCountsGuestGuideViews: (startDate, endDate) =>
    httpV2.get(
      `dashboard/counts/guest-guide-views?startDate=${startDate}&endDate=${endDate}`,
    ),
  dashboardCountsAvgGuestRating: (startDate, endDate) =>
    httpV2.get(
      `dashboard/counts/avg-guest-rating?startDate=${startDate}&endDate=${endDate}`,
    ),
  dashboardCountsSurveyResponses: (startDate, endDate) =>
    httpV2.get(
      `dashboard/counts/survey-responses?startDate=${startDate}&endDate=${endDate}`,
    ),
  dashboardCountsExtendStaysMessagesSent: (startDate, endDate) =>
    httpV2.get(
      `dashboard/counts/extend-stays-messages-sent?startDate=${startDate}&endDate=${endDate}`,
    ),
  dashboardCountsLeadsGenerated: (startDate, endDate) =>
    httpV2.get(
      `dashboard/counts/leads-generated?startDate=${startDate}&endDate=${endDate}`,
    ),
  dashboardCountsOrdersReceived: (startDate, endDate) =>
    httpV2.get(
      `dashboard/counts/orders-received?startDate=${startDate}&endDate=${endDate}`,
    ),
  dashboardCountsWorkOrdersCreated: (startDate, endDate) =>
    httpV2.get(
      `dashboard/counts/work-orders-created?startDate=${startDate}&endDate=${endDate}`,
    ),
};

export default DashboardService;
